
<template>
  <div>
    <text-input :value="data.name" label="Name" ref="name"/>
    <long-text-input :value="data.description" label="Eventbeschreibung" ref="description"/>
    <long-text-input :value="data.longDescription" label="Programm" ref="longDescription"/>
    <text-input :value="data.addressLine" label="Addresse" ref="address"/>
    <text-input :value="data.mediaLink" label="Link zum Video" ref="link"/>
    <div class="position-relative">
      <div class="form-group">
        <label for="input_date">Datum</label>
        <date-picker v-model="date" :config="datePickerOptions" id="input_date"></date-picker>
      </div>
    </div>
    <file-input v-model="data.images" label="Bilder" type="image" :max-files="100"/>
    <div class="admin-info">
      <p>
        Das erste Bild wird als Titelbild verwendet, die anderen Bilder werden als Impressionen
        aufgelistet.
      </p>
    </div>
    <br>
    <button class="btn btn-primary" @click="save">Save</button>
  </div>
</template>

<script>
import moment from "moment";
import ResultList from "../result/List";

export default {
  props: ["data"],
  components: { ResultList },
  data() {
    return {
      date: this.data.date && this.data.date.format("DD.MM.YYYY"),
      datePickerOptions: {
        useCurrent: false,
        format: "DD.MM.YYYY"
      }
    };
  },
  methods: {
    saveEvent() {
      let form = new FormData();
      const form_prefix = "edit_event";

      if (this.date) form.append(form_prefix + "[date]", this.date);

      for (let i = 0; i < this.data.images.length; i++) {
        form.append(
          form_prefix + "[images][" + i + "]",
          this.data.images[i].id
        );
      }
      form.set(form_prefix + "[submit]", null);
      return axios.post(
        `/api/${store.state.language}/event/${this.data.id}/edit`,
        form
      );
    },
    save() {
      store.commit("addSavingProcess");
      Promise.all([
        this.saveEvent(),
        this.$refs.name.save(),
        this.$refs.description.save(),
        this.$refs.longDescription.save(),
        this.$refs.address.save(),
        this.$refs.link.save()
      ])
        .then(([{ data }]) => {
          store.commit("finishSavingProcess");

          if(data.date)
            this.data.date = moment(data.result.date.date);
        })
        .catch(err => {
          store.commit("finishSavingProcess");
          console.error(err);
          alert("Beim Speichern ist ein Fehler aufgetreten.");
        });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/admin/event/General.vue